import { takeLatest, put, call } from 'redux-saga/effects';
import GetValueDashboardForIndividualTypes from './GetValueDashboardForIndividual.types';
import { fetchValueDashboardForIndividualData } from './GetValueDashboardForIndividual.services';
import {
	getValueDashboardForIndividualSuccess,
	getValueDashboardForIndividualFailure,
} from './GetValueDashboardForIndividual.action';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

export function* fetchValueDashboardForIndividualDataSaga(payload: any) {
	try {
		const Key = 'fetchValueDashboardForIndividualDataKey';
		const encryptedPayload = encryptData(payload.payload, Key);
		const requestPayload = {
			token: encryptedPayload,
			getMethod: payload.payload?.getMethod,
		};
		// @ts-ignore
		const responseData = yield call(
			fetchValueDashboardForIndividualData as any,
			requestPayload,
		);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				console.log('Received failure response');
				yield put(getValueDashboardForIndividualFailure(responseData.data));
			} else {
				console.log('Received success response');
				yield put(getValueDashboardForIndividualSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		console.error('Error in fetchSectionWiseData:', error);
		yield put(
			getValueDashboardForIndividualFailure(
				error?.response?.data?.message || 'An error occurred',
			),
		);
	}
}

export function* onGetValueDashboardForIndividualStart(): Generator<any, void, any> {
	yield takeLatest(
		GetValueDashboardForIndividualTypes.GET_VALUE_DASHBOARD_FOR_INDIVIDUAL_START as any,
		fetchValueDashboardForIndividualDataSaga,
	);
}

export function* getValueDashboardForIndividualSaga(): Generator<any, void, any> {
	yield call(onGetValueDashboardForIndividualStart);
}
